import { useState } from "react";

/**
 * Open/close состояние модалок УДГ/УДГК (регистрация команд, логи,
 * отклонения) и связанный с ними confirm-диалог. Main.jsx/UnitBlockWidget
 */
export function useUnitCommands() {
	const [modals, setModals] = useState({
		deviationLog: false,
		udgkLog: false,
		udgLog: false,
		udgkForm: false,
		udgForm: false,
	});

	const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
	const [udgFormSubmitted, setUdgFormSubmitted] = useState(false);

	const openModal = (key) => setModals((prev) => ({ ...prev, [key]: true }));

	const closeModal = (key) =>
		setModals((prev) => ({ ...prev, [key]: false }));

	const toggleConfirmDialog = () => setConfirmDialogOpen((prev) => !prev);

	const markUdgFormSubmitted = () => setUdgFormSubmitted(true);

	// УДГ-форма закрывается и сбрасывает "результат отправки" всегда вместе
	const closeUdgForm = () => {
		closeModal("udgForm");
		setUdgFormSubmitted(false);
	};

	return {
		modals,
		openModal,
		closeModal,
		confirmDialogOpen,
		toggleConfirmDialog,
		udgFormSubmitted,
		markUdgFormSubmitted,
		closeUdgForm,
	};
}
